module.exports = __webpack_public_path__ + "static/img/sulfur_256.5c7d832.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sulfur_256.png
// module id = NCma
// module chunks = 0